module.exports = __webpack_public_path__ + "static/media/DSA PHONO II.c7b2e8ed.png";